export default __webpack_public_path__ + "static/media/paiGowTableLandscape.a8c990d3.webp";